import { Attachable } from './attachable';
import {AttachmentType} from './enums/attachmentType';

/**
 * This class could later be deprecated. Use Attachment with the corersponding mime-type instead.
 */
export class Sticker implements Attachable {

  public id: number;
  public projectKey: string;
  public issueId: number;
  public fileName: string;
  public fileUrl: string;
  public imageData: string;
  public iconName: string;
  public iconColor: string;
  public comment: string;
  public order: number;
  public size: number;
  public readonly type = AttachmentType.TaskcardAttachment;

  constructor(
    id?: number,
    issueId?: number,
    projectKey?: string,
    fileName?: string,
    imageData?: string,
    iconName?: string,
    iconColor?: string,
    comment?: string,
    order?: number,
    size?: number
  ) {
    this.id         = id         || 0;
    this.projectKey = projectKey || '';
    this.issueId    = issueId    || 0;
    this.fileName   = fileName   || '';
    this.imageData  = imageData  || '';
    this.iconName   = iconName   || '';
    this.iconColor  = iconColor  || '';
    this.comment    = comment    || '';
    this.order      = order      || 0;
    this.size       = size       || 0;
  }

  public update(other: Sticker) {
    this.issueId    = other.issueId;
    this.fileName   = other.fileName;
    this.imageData  = other.imageData;
    this.iconName   = other.iconName;
    this.iconColor  = other.iconColor;
    this.comment    = other.comment;
    this.order      = other.order;
    this.size       = other.size;
  }
}
